import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { ErrorBoundary } from './components/common/ErrorBoundary/ErrorBoundary';
import { env } from './config/env';
import { DEFAULT_LANGUAGE, getDictionary } from './config/locale/locale';
import { router } from './routes/appRouter';
import { store } from './store/store';

env();

export function App() {
  // Rendered above the Redux <Provider>, so the bootstrap label reads the
  // default locale directly rather than through the useTranslation hook.
  const { app } = getDictionary(DEFAULT_LANGUAGE);

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Suspense fallback={<div className="appLoadingFallback">{app.loading}</div>}>
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </Suspense>
      </Provider>
    </ErrorBoundary>
  );
}
